const mainTheme = {
  colorPrimary: "#eae5f0",
  headerPaddingTop: "50px",
  bodyPaddingHorizontal: "30px",
  backgroundColor: "#4c3775",
  featuredColor: "#C1272D",
  paddingShort: "20px",
};
export default mainTheme;
